import moment from 'moment';
import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import {  Col, Container, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import swal from 'sweetalert';
import { ThreeDotSpinner } from '../../common/loader/loader';
import productService from '../../service/ProductService';
import { OrderStatus, ProductStatus } from '../../common/constant';

export const ProductManagemet = () => {

  const [Loader, setLoader] = useState(false)
  const [products, setProducts] = useState([])
  const [pagination, setPagination] = useState({ pageNumber: 1, pageSize: 10, pageRange: 0, totalCount: 0 })
  const [status,setStatus] = useState("");

  useEffect(() => {
      fetchProducts();
  }, [])

  const fetchProducts =async (pageNumber = pagination.pageNumber, pageSize = pagination.pageSize, status = "") => {
    setLoader(true);

    const params = {page: pageNumber - 1, size: pageSize,assignValidator : true,status:status}
    const response = await productService.filter(params);
    if (response.status == 200) {
      setLoader(false);
      setProducts(response.data.data.orders)
      setPagination(prev => ({
        ...prev,
        pageNumber,
        pageSize,
        totalCount: response.data.data.count
      }));
    }
  }

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      View
    </Tooltip>
  );

  const renderToggleTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      enable/disable
    </Tooltip>
  );

  const handlePageChange = (pageNumber) => {
    setPagination({
      ...pagination,
      pageNumber: pageNumber
    })
    fetchProducts(pageNumber,pagination.pageSize,status);

  };

  const onProductStatusChange = async (userId) => {

    const response = await productService.updateStatus(userId);
    if (response.status == 200) {
      swal({ icon: 'success', text: response.data.message, button: "OK" });
      fetchProducts();
    }
  }

  const handleFilterChange = (e, type) => {
    let value = e.target.value.trim();
    if (value === '' || value === 'all') value = null;

    setPagination(prev => ({
      ...prev,
      pageNumber: 1
    }));
    setStatus(value);
    fetchProducts(1,pagination.pageSize,value);
  };

  return (
    <>
      {Loader && <ThreeDotSpinner />}
      <div className="dashboard-main-area">
        <Container fluid>
          <div className="dashboard-area-heading management-heading">

            <Row className="row justify-content-center align-items-center mb-2">
              <Col md={12}>
                <div className="d-flex justify-content-between mb-2">
                  <div className="d-flex ">
                    <h2 className="align-self-center m-0">Product Management</h2>
                  </div>
                   <div className='filter-section'>
                    <select className='form-select' onChange={(e) => handleFilterChange(e, 'status')}>
                      <option value='all'>All</option>
                      {
                        Object.entries(ProductStatus).map(([key, label]) => (
                          <option key={key} value={key}>{label}</option>
                        ))
                      }
                    </select>
                  </div>
                </div>               
              </Col>           
            </Row>

            <Row className="pb-4 justify-content-center">
              <Col md={12}>
                <div className="audit-request-box">
                  <Table responsive="sm" className="UserListTable">
                    <thead>
                      <tr>
                        <th>Creation Date</th>   
                        <th>Product ID</th>        
                        <th>Name</th>               
                        <th>Price</th>
                        <th>Category</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody> 
                      { products.length > 0 &&
                        products.map((order, index) => (
                          <tr key={index}>
                            <td>{moment(order.product.createdAt).format('DD-MM-YYYY')}</td>
                            <td>{order.product._id}</td>
                            <td>{order.product.name}</td>
                            <td>{order.product.price}</td>
                            <td>
                              {order.product?.category?.name}
                            </td>     
                            <td>{OrderStatus[order?.status] || order?.status}</td>
                            <td>
                                <div className="action-boxes"> 
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={renderTooltip}
                                >
                                  <Link to={`/products/${order.product._id}`}>
                                    <div className="view-btn-main" style={{ cursor: "pointer" }}>
                                      <i className="fa-solid fa-eye"></i>
                                    </div>
                                  </Link>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={renderToggleTooltip}
                                >
                                <Form.Check
                                    type="switch"
                                    id={`custom-switch-${order.product._id}`}
                                    onClick={() =>
                                      swal({
                                        title: "Confirm",
                                        text: `Are you sure you want to ${order.product?.enabled ? "disable product?" : "Enable product?"}`,
                                        icon: "warning",
                                        buttons:{
                                          cancel: "Cancel",  
                                          confirm: "Yes"    
                                        },
                                      }).then((value) => {
                                        if (value) {
                                          {onProductStatusChange(order.product._id)}
                                        } else {
                                          console.log("NO button clicked or popup closed");
                                        }
                                      })
                                    }
                                    checked={order.product?.enabled}
                                  />
                                </OverlayTrigger>
                                </div>
                            </td>

                          </tr>
                        ))
                      }

                      {
                        pagination.totalCount == 0 &&

                        <tr className="no-dat-found-box">
                          <td colSpan={10}>
                            <img src={require("../../assets/images/no-data-bg.gif")} alt="no-data-image" />
                            <h3 className="text-center">
                              No data found
                            </h3>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </Table>
                  {pagination.totalCount > pagination.pageSize &&
                    <Pagination
                      activePage={pagination.pageNumber}
                      itemsCountPerPage={pagination.pageSize}
                      totalItemsCount={pagination.totalCount}
                      pageRangeDisplayed={pagination.pageRange}
                      onChange={(e) => handlePageChange(e)}
                      prevPageText={"Prev"}
                      nextPageText={"Next"}
                    />
                  } 
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};
